export default __webpack_public_path__ + "mma-live.png";